import { PocButton, PocIcon, PocTypography } from 'commons/components/components-wrapper';
import { RefObject, useRef } from 'react';
import { FileUploaderLayout } from './file-uploader.style';

export interface FileUploaderComponentProps {
    buttonText: string;
    fileTypes: string[];
    onLoadFile: (ev: React.ChangeEvent<HTMLInputElement>) => void;
    isUploadDisabled: boolean;
    multiple?: boolean;
    title?: string;
    subtitle?: string;
}

export const FileUploaderComponent: React.FC<FileUploaderComponentProps> = (props) => {
    const { title, subtitle, buttonText, fileTypes, onLoadFile, isUploadDisabled, multiple = true } = props;

    const fileInputRef = useRef() as RefObject<HTMLInputElement>;

    return (
        <FileUploaderLayout>
            <div className="uploadInfo" data-testid="file-uploader-info">
                <PocIcon name="cloud_upload" />
                {title ? <PocTypography variant="title6">{title}</PocTypography> : undefined}
                {subtitle ? <PocTypography variant="body1">{subtitle}</PocTypography> : undefined}
            </div>
            <div className="uploadAction" data-testid="file-uploader-action">
                <PocButton variant="tertiary" onClick={() => fileInputRef.current?.click()} disabled={isUploadDisabled}>
                    {buttonText}
                </PocButton>
            </div>
            <input
                onChange={onLoadFile}
                onClick={(ev) => ((ev.target as HTMLInputElement).value = '')}
                multiple={multiple}
                ref={fileInputRef}
                type="file"
                data-testid="file-uploader-input"
                hidden
                accept={fileTypes.join(',')}
            />
        </FileUploaderLayout>
    );
};
